import {
    FETCH_WALLET_TRANSACTIONS_REQUEST,
    FETCH_WALLET_TRANSACTIONS_SUCCESS,
    FETCH_WALLET_TRANSACTIONS_FAILURE,
} from "./types";

import {
    fetchWalletTransactions,
} from "../../services/walletTransactionService";

export const fetchWalletTransactionsRequest = () => ({
    type: FETCH_WALLET_TRANSACTIONS_REQUEST,
});

export const fetchWalletTransactionsSuccess = (
    transactions
) => ({
    type: FETCH_WALLET_TRANSACTIONS_SUCCESS,
    payload: transactions,
});

export const fetchWalletTransactionsFailure = (
    error
) => ({
    type: FETCH_WALLET_TRANSACTIONS_FAILURE,
    payload: error,
});

export const fetchWalletTransactionsAction =
    (page = 1, size = 10) =>
    async (dispatch) => {
        dispatch(
            fetchWalletTransactionsRequest()
        );

        try {
            const response =
                await fetchWalletTransactions(
                    page,
                    size
                );

            if (response.success) {
                dispatch(
                    fetchWalletTransactionsSuccess(
                        response.data
                    )
                );

                return response;
            }

            dispatch(
                fetchWalletTransactionsFailure(
                    response.error
                )
            );

            return response;
        } catch (error) {
            const err =
                error.message ||
                "Failed to fetch wallet transactions.";

            dispatch(
                fetchWalletTransactionsFailure(
                    err
                )
            );

            return {
                success: false,
                error: err,
            };
        }
    };